import React, { useEffect,useState } from "react";
import { showConfirm, showSuccess, showError } from "component/utils/SweetAlert";
import axios from "axios";

import Sidebar from "component/Sidebar";
import Navbar from "component/Navbar";
import CategoryDatatables from "component/master/category/CategoryDatatables";
import CategoryModalForm from "component/master/category/CategoryModalForm";

function Category() {
  const [modalMode, setModalMode] = useState(null);
  const [selectedCategory, setSelectedCategory] = useState(null);
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [category, setCategory] = useState([]);

  const fetchCategory = async () => {
    const token = localStorage.getItem("token");
    try {
      const response = await fetch(`${process.env.REACT_APP_API}/category`, {
        method: "GET",
        headers: {
          "Authorization": `Bearer ${token}`,
          "Content-Type": "application/json"
        }
      });
  
      if (!response.ok) throw new Error("Gagal mengambil data category");
  
      const data = await response.json();
      setCategory(data.data);
    } catch (error) {
      console.error("Error fetching category:", error);
    }
  };

  useEffect(() => {
      document.title = "Green Hill Kemuning | Category";
      window.scrollTo(0, 0);
      fetchCategory();
  }, []);

  const handleAddCategory = () => {
    setModalMode("add");
    setSelectedCategory(null);
    setIsModalOpen(true);
  }

  const handleEditCategory = (category) => {
    setModalMode("edit");
    setSelectedCategory(category);
    setIsModalOpen(true);
  }

  const handleDeleteCategory = async (category) => {
    try {
      const confirmed = await showConfirm({
        title: 'Hapus Category',
        text: `Apakah Anda yakin ingin menghapus Category ${category.name}?`,
        confirmButtonText: 'Hapus'
      });
      if (!confirmed) return;
  
      if (!category?.category_id) {
        alert("Category ID tidak ditemukan");
        return;
      }

      const response = await axios.delete(
        `${process.env.REACT_APP_API}/category/${category.category_id}`
      );

  
      if (response.status === 200 || response.status === 201) {
        showSuccess(response.data.message || "Category berhasil dihapus");
        fetchCategory();
      } else {
        showError(response.data.message || "Gagal menghapus Category");
      }
    } catch (error) {
      console.error("Error deleting user:", error);
      showError(error.response?.data?.message || "Terjadi kesalahan saat menghapus Category");
    }
  };  

  const closeModal = () => {
    setIsModalOpen(false);
  }
      
  return (
    <div class="layout-wrapper layout-content-navbar">
      <div class="layout-container">
        <Sidebar />

        <div class="layout-page" style={{ backgroundColor: "#f8f9fa" }}>
            <Navbar />
            <div class="content-wrapper">
                <div class="container-xxl flex-grow-1 container-p-y">
                  <div class="row px-4">
                      <div class="card shadow p-3">
                        <div class="card-body">
                          <div class="row">
                            <div className="d-flex justify-content-between align-items-center">
                              <h5 className="card-title m-0">Category Management</h5>
                              <i className="bx bxs-plus-square" 
                                style={{ color: "blue", fontSize: 50, cursor: "pointer" }} 
                                onClick={handleAddCategory}>
                              </i>
                            </div>
                            <CategoryDatatables data={category} onEditCategory={handleEditCategory} onDeleteCategory={handleDeleteCategory}/>
                          </div>
                        </div>  
                      </div>
                  </div>
                </div>
            </div>
        </div>
      </div>
      <div class="layout-overlay layout-menu-toggle"></div>

      {isModalOpen && (
        <div className="modal fade show" style={{ display: "block" }}>
          <CategoryModalForm mode={modalMode} categoryData={selectedCategory} closeModal={closeModal} onSuccess={fetchCategory}/>
        </div>
      )}

    </div>
  );
}

export default Category;
